import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Components } from '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import { PROVIDERS } from '../../../dashboard/model/ResendOptions';
import { ILink } from '../../../dashboard/model/ILink';

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
})
export class ShareModalComponent {
  @ViewChild('shareModal') shareModal!: ElementRef<Components.BdbMlShare>;
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  @Output() optionSelected: EventEmitter<CustomEvent> = new EventEmitter();
  @Input() resendData: ILink;

  constructor() {}

  onOptionClick(event: CustomEvent): void {
    const { value } = event.detail;
    let id: string;
    let provider: string;

    if (value === 'sms') {
      provider = this.resendData.provider !== 1 ? PROVIDERS[1] : PROVIDERS[4];
      id = '0';
    } else if (value === 'whatsapp') {
      provider = PROVIDERS[3];
      id = '3';
    } else if (value === 'email') {
      provider = PROVIDERS[2];
      id = '2';
    }

    const customEvent = new CustomEvent('optionSelected', {
      detail: { id, provider },
      bubbles: true,
      cancelable: true,
    });

    this.optionSelected.emit(customEvent);
    this.closeModal.emit();
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
